<template>
  <div class="import-spreadsheet-modal">
    <LocalFileUploaderModal
      :modalTitle="$i18nPresenter.t('Import spreadsheet')"
      isModalVisible
      :staticState="staticState"
      :uploadingState="uploadingState"
      :convertingState="convertingState"
      :uploadError="spreadsheetImportError"
      :featureName="UploadFeatureName.IMPORT_SPREADSHEET"
      :fileFormat="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
      :instructionText="instructionText"
      @hide="hide()"
    >
      <template #additionalInformationSection>
        <div class="text-sm">
          <p>{{ $i18nPresenter.t('MS Excel, Libre Office, Google Sheets and Numbers') }}</p>
          <div class="pt-4 pb-4">
            <div>
              1.
              <a
                class="local-file-uploader__link"
                href="https://s3.amazonaws.com/public.ahaslide.com/template-sheet/ahaslides-quiz-template.xlsx"
                download
                @click="handleDownloadTemplate"
              >{{ $i18nPresenter.t('Download our template') }}</a>
            </div>
            <p>2. {{ $i18nPresenter.t('Fill it out and save as .xlsx') }}</p>
            <p>
              3. {{ $i18nPresenter.t('Upload here') }}
            </p>
          </div>
        </div>
      </template>
    </LocalFileUploaderModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/util'
import textUtils from '@/utils/textUtil'
import PresentationUtils from '@/utils/presentation'
import EventBus from '@/eventBus'
import eventCategories from '@/constant/eventCategories'
import UploadFeatureName from '@/constant/uploadFeatureName'

// components
import LocalFileUploaderModal from '@/components-v2/modals/LocalFileUploaderModal.vue'

export default {
  components: {
    LocalFileUploaderModal,
  },
  data() {
    return {
      file: null,
      UploadFeatureName,
    }
  },
  computed: {
    ...mapGetters('spreadsheetUploader', ['spreadsheetImportError', 'spreadsheetImportStatus']),

    staticState() {
      return this.spreadsheetImportStatus === 1
    },
    uploadingState() {
      return this.spreadsheetImportStatus === 2
    },
    convertingState() {
      return this.spreadsheetImportStatus === 3
    },
    instructionText() {
      return this.$i18nPresenter.t('XLSX - Max: 1MB')
    },
  },
  mounted() {
    EventBus.$on('ImportSheet: handleSuggestPresentationTitle', (slide) => {
      this.handleSuggestPresentationTitle(slide)
    })
  },
  destroyed() {
    EventBus.$off('ImportSheet: handleSuggestPresentationTitle')
  },
  methods: {
    ...mapActions(['setImportSheetModalStateAction']),

    hide() {
      this.setImportSheetModalStateAction(false)
    },
    handleDownloadTemplate() {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Download our template',
        'AhaSlides Quiz Template',
      )
    },
    handleSuggestPresentationTitle(slide) {
      const validSlideTitle = slide.title && slide.title.trim()
      let firstSlideTitle = validSlideTitle || null

      if (slide.canvasBlocks && !firstSlideTitle) {
        firstSlideTitle = textUtils.getFirstCanvasBlockContent(slide.canvasBlocks)
      }
      if (firstSlideTitle) {
        PresentationUtils.handleSuggestPresentationTitle(firstSlideTitle)
      }
    },
  },
}
</script>

<style>
.import-spreadsheet-modal {
  .aha-modal__header {
    @apply pb-2;
  }
}
.local-file-uploader__link {
  @apply underline hover:no-underline cursor-pointer;
}
</style>
